import { Space } from 'antd';
import { UserProjectRole } from 'api/types';
import { DownloadAction, UploadAction, SyncNodeData } from 'components/actions';
import { EditType, EditTypeProps } from 'components/button/edit-type';
import { useDataSheetWrapper } from 'components/layouts/components/data-sheet/wrapper';
import { useProject } from 'context/project-context';
import { COLORS } from 'helpers/constants';
import { ManageNode } from './table-section/node/manage-node';

export const HeaderActions = () => {
  const { projectInfo } = useProject();
  const { startEditType, finishEditType, editTypeisOpened, nodeTypeId, isConnectionType, nodesList } =
    useDataSheetWrapper();
  const iconProps = nodeTypeId ? { style: { color: COLORS.PRIMARY.GRAY_DARK } } : {};

  const editTypeProps: EditTypeProps = nodeTypeId
    ? {
        onClick: startEditType,
        open: editTypeisOpened,
        onOpenChange: (open: boolean) => {
          !open && finishEditType();
          return open;
        },
      }
    : ({} as EditTypeProps);

  const canEdit = projectInfo?.role === UserProjectRole.Owner || projectInfo?.role === UserProjectRole.Editor;

  return (
    <Space size={8}>
      {nodesList?.length ? (
        <>
          {projectInfo && projectInfo?.role !== UserProjectRole.Viewer && (
            <>
              {!isConnectionType && <ManageNode />}
              {!isConnectionType && <DownloadAction icon={iconProps} nodeTypeIds={[nodeTypeId ?? '']} />}
              {!isConnectionType && <UploadAction icon={iconProps} />}
            </>
          )}

          {canEdit && <EditType icon={iconProps} {...editTypeProps} />}

          {!isConnectionType && <SyncNodeData />}
        </>
      ) : (
        <></>
      )}
    </Space>
  );
};
